import { httpCreate } from './http';

const http = httpCreate('/srv/free-invite-activity-help');

export const freeInviteActivityHelp = {
	getList(id, params) {
		return http.get(`/${id}`, { params });
	},
};
